// extracted by mini-css-extract-plugin
module.exports = {"StatusTabs":"StatusTabs_StatusTabs__2jtDs","StatusTable":"StatusTabs_StatusTable__8Xdti"};